import React from 'react';
import styled from 'styled-components';

function ContactPhone(props) {
    return (
        <PhoneWrapper data-test-id="contact-phone" className="contact-phone">
            <PhoneNumber data-test-id="phone">850-424-5125</PhoneNumber>
            <PhoneText data-test-id="description">
                {props.isAvailText ? 'AVAIL 7AM-7PM CST' : 'We are here to help'}
            </PhoneText>
        </PhoneWrapper>
    );
}

export default ContactPhone;

export const PhoneWrapper = styled.div`
    display: block;
    width: 100%;
    margin-left: auto;
    margin-right: 0;
    @media (min-width: 768px) {
        width: 175px;
        margin-top: 12px;
        margin-right: 10px;
    }
    &.contact-phone {
        display: block;
    }
`;

export const PhoneNumber = styled.a.attrs({
    href: 'tel:+18504245125',
})`
    display: block;
    width: auto;
    font-weight: 400;
    font-size: 18px;
    color: rgba(255, 255, 255, 0.8);
    text-align: right;
    &:hover,
    &:active {
        text-decoration: none;
        color: rgba(255, 255, 255, 1);
    }
    @media (min-width: 768px) {
        font-size: 25px;
    }
    @media (max-width: 390px) {
        font-size: 14px;
    }
`;

export const PhoneText = styled.span`
    display: block;
    width: auto;
    text-transform: uppercase;
    line-height: 1;
    font-weight: 600;
    font-size: 12px;
    text-align: right;
    color: rgba(255, 255, 255, 0.8);
    @media (min-width: 768px) {
        line-height: 2.2;
        font-size: 14px;
    }
    @media (max-width: 390px) {
        font-size: 8px;
    }
`;
